//@ts-check
import useEventCallback from './useEventCallback';
import useContactSchema from './useContactSchema';
export default {
  useEventCallback: useEventCallback,
  useContactSchema: useContactSchema
};